import React, { useContext, useMemo } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import LanguagePrefixContext from '../../../contextProviders/LanguagePrefixContext';
import ShopProductItem from './ShopProductItem';
import ServerSideList from '../../../commonComponents/lists/ServerSideList';
import LoggedUserContext from '../../../contextProviders/LoggedUserContext';

function ShopSearchList({
  t,
  query,
  marketInfos,
  isLandingPage,
  onCountUpdate,
}) {
  const languagePrefix = useContext(LanguagePrefixContext);
  const { loggedUser } = useContext(LoggedUserContext);

  const columns = [
    {
      field: 'name',
      textAlign: 'center',
      title: '',
      template: item =>
        renderToStaticMarkup(
          <LanguagePrefixContext.Provider value={languagePrefix}>
            <ShopProductItem product={item} t={t} loggedUser={loggedUser} />
          </LanguagePrefixContext.Provider>,
        ),
    },
  ];

  const pageSize = isLandingPage ? 8 : 12;
  const dataSourceParams = useMemo(
    () => ({
      populate: ['variations', 'packVariations.variation'],
    }),
    [],
  );

  const combinedQuery = useMemo(
    () => ({
      ...query,
      country: marketInfos.localCountry,
      currency: marketInfos.localCurrency,
      language: marketInfos.localLanguage,
    }),
    [
      query,
      marketInfos.localCountry,
      marketInfos.localCurrency,
      marketInfos.localLanguage,
    ],
  );

  return (
    <ServerSideList
      columns={columns}
      id="shopList"
      dataSourceURL="/table/market/product/list"
      dataSourceHeaders={{
        'Accept-Version': '1.0.0',
        'X-Gamification-API': 'Games',
      }}
      onDataFetch={raw => {
        if (raw?.meta?.total !== undefined) {
          // send count up to parent
          onCountUpdate(raw?.meta?.total);
        }
      }}
      dataSourceParams={dataSourceParams}
      query={combinedQuery}
      defaultPageSize={pageSize}
    />
  );
}

ShopSearchList.propTypes = {
  t: PropTypes.func.isRequired,
  query: PropTypes.shape({
    category: PropTypes.string.isRequired,
    maxPrice: PropTypes.number.isRequired,
    sort: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
    productType: PropTypes.string.isRequired,
  }).isRequired,
  marketInfos: PropTypes.shape({
    localCountry: PropTypes.string.isRequired,
    localCurrency: PropTypes.string.isRequired,
    localLanguage: PropTypes.string.isRequired,
  }).isRequired,
  isLandingPage: PropTypes.bool,
  onCountUpdate: PropTypes.func.isRequired,
};

ShopSearchList.defaultProps = {
  isLandingPage: false,
};

export default React.memo(translate(ShopSearchList));
